
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 9.83V6.766C9 6.343 9.335 6 9.75 6s.75.343.75.766V9.83a.758.758 0 01-.75.766A.758.758 0 019 9.83zm12.75.766c.415 0 .75-.343.75-.766V6.766A.758.758 0 0021.75 6a.758.758 0 00-.75.766V9.83c0 .423.335.766.75.766zM7.5 24.23V13.66H24v3.063h1.5v-5.975c0-.93-.727-1.684-1.625-1.684h-.625v.766c0 .844-.672 1.532-1.5 1.532-.827 0-1.5-.688-1.5-1.532v-.766h-9v.766c0 .844-.672 1.532-1.5 1.532s-1.5-.688-1.5-1.532v-.766h-.625C6.727 9.064 6 9.818 6 10.748v13.483c0 .927.727 1.684 1.625 1.684H16.5v-1.532H7.625c-.068 0-.125-.072-.125-.152z","fill":"#D2D5D9"}}),_c('path',{attrs:{"d":"M22.5 9.83V6.766A.758.758 0 0021.75 6a.758.758 0 00-.75.766V9.83c0 .423.335.766.75.766s.75-.343.75-.766zm-12.75.766A.758.758 0 019 9.83V6.766C9 6.343 9.335 6 9.75 6s.75.343.75.766V9.83a.758.758 0 01-.75.766zM24 24.23V13.66H7.5v3.063H6v-5.975c0-.93.727-1.684 1.624-1.684h.626v.766c0 .844.673 1.532 1.5 1.532s1.5-.688 1.5-1.532v-.766h9v.766c0 .844.672 1.532 1.5 1.532s1.5-.688 1.5-1.532v-.766h.625c.898 0 1.625.754 1.625 1.684v13.483c0 .927-.727 1.684-1.625 1.684H15v-1.532h8.875c.068 0 .125-.072.125-.152z","fill":"#D2D5D9"}}),_c('path',{attrs:{"fill":"#D2D5D9","d":"M9.25 15.423h3v3.064h-3zM14.25 15.423h3v3.064h-3zM19.25 15.423h3v3.064h-3zM9.25 19.508h3v3.064h-3zM14.25 19.508h3v3.064h-3zM19.25 19.508h3v3.064h-3z"}})])
          )
        }
      }
    